export const todosData = [
  {
    id: 'phase1',
    title: 'PHASE 1: MORNING ROUTINE (Weekdays)',
    description: 'Tasks to start the day feeling energized and organized.',
    images: [
      'https://via.placeholder.com/150?text=Morning+Routine+1',
      'https://via.placeholder.com/150?text=Morning+Routine+2'
    ],
    tables: [
      [
        ['Time', 'Activity'],
        ['6:30 AM', 'Wake up'],
        ['7:00 AM', 'Breakfast']
      ],
      [
        ['Tip', 'Details'],
        ['Hydration', 'Drink water first thing in the morning']
      ]
    ],
    completed: false,
    expanded: true,
    items: [
      {
        id: 'wake-up',
        title: 'Wake Up & Get Ready',
        description: 'Activities to transition from sleeping to being fully ready for the day.',
        images: ['https://via.placeholder.com/100?text=Wake+Up'],
        tables: [
          [
            ['Step', 'Action'],
            ['1', 'Turn off alarm'],
            ['2', 'Stretch']
          ]
        ],
        completed: true,
        items: [
          { 
            id: 'alarm', 
            title: 'Turn off alarm', 
            description: 'Stop the alarm to officially begin the day.', 
            images: [
              'https://via.placeholder.com/80?text=Alarm1',
              'https://via.placeholder.com/80?text=Alarm2'
            ],
            tables: [
              [['Item', 'Detail'], ['Type', 'Digital Clock']],
              [['Sound', 'Level'], ['Beep', 'Medium']]
            ],
            completed: true 
          },
          { 
            id: 'stretch', 
            title: 'Do a 5-minute stretch', 
            description: 'Gently loosen muscles after sleeping.', 
            images: ['https://via.placeholder.com/80?text=Stretch'],
            tables: [
              [['Exercise', 'Duration'], ['Neck rolls', '1 min'], ['Arm circles', '1 min']]
            ],
            completed: false 
          }
        ]
      },
      {
        id: 'pets',
        title: 'Pet Care',
        description: 'Daily responsibilities for keeping pets happy and healthy.',
        images: [
          'https://via.placeholder.com/100?text=Pets1',
          'https://via.placeholder.com/100?text=Pets2'
        ],
        tables: [
          [['Pet', 'Task'], ['Cat', 'Feed'], ['Dog', 'Walk']],
          [['Reminder', 'Frequency'], ['Vet check-up', 'Every 6 months']]
        ],
        completed: false,
        items: [
          { 
            id: 'feed-cat', 
            title: 'Feed the cat', 
            description: 'Provide the cat with fresh food and water.', 
            images: ['https://via.placeholder.com/80?text=Cat'],
            tables: [
              [['Food', 'Amount'], ['Dry', '50g']],
              [['Water', 'Amount'], ['Fresh', '200ml']]
            ],
            completed: true 
          }
        ]
      }
    ]
  },
  {
    id: 'phase2',
    title: 'PHASE 2: EVENING ACTIVITIES (Weekdays)',
    description: 'Tasks to wind down and prepare for the next day.',
    images: [
      'https://via.placeholder.com/150?text=Evening+Routine',
      'https://via.placeholder.com/150?text=Evening+Relax'
    ],
    tables: [
      [['Time', 'Activity'], ['6:00 PM', 'Exercise'], ['8:00 PM', 'Dinner']],
      [['Tip', 'Reason'], ['Avoid heavy meals late', 'Better sleep quality']]
    ],
    completed: false,
    expanded: false,
    items: [
      {
        id: 'exercise',
        title: 'Exercise',
        description: 'Physical activities to maintain health and relieve stress.',
        images: ['https://via.placeholder.com/100?text=Exercise'],
        tables: [
          [['Activity', 'Duration'], ['Jogging', '20 min']],
          [['Calories Burned', 'Approximate'], ['Jogging', '150 kcal']]
        ],
        completed: false,
        items: [
          { 
            id: 'yoga', 
            title: 'Do a 15-minute yoga session', 
            description: 'Stretch and relax muscles with gentle yoga poses.', 
            images: [
              'https://via.placeholder.com/80?text=Yoga1',
              'https://via.placeholder.com/80?text=Yoga2'
            ],
            tables: [
              [['Pose', 'Duration'], ['Downward Dog', '2 min']],
              [['Pose', 'Benefit'], ['Tree Pose', 'Improves balance']]
            ],
            completed: false 
          }
        ]
      }
    ]
  }
];
